export default "/images/vendor/flag-icon-css/flags/1x1/pk.svg?0e17f31b0f156316ef2028671d12825f";